import { Stack, Button, SelectChangeEvent } from '@mui/material';
import { Dayjs } from 'dayjs';
import { useCallback } from 'react';
import FilterDatePicker from 'src/components/filter-form/filter-date-picker';
import FilterSingleSelect from 'src/components/filter-form/filter-single-select';
import Iconify from 'src/components/iconify';
import UserSearchAutocomplete, { UserOption } from 'src/components/ui-kit/user-search-autocomplete';
import {
  GoldWithdrawFilters,
  GoldWithdrawFilterKey,
  GoldWithdrawFilterValue,
} from 'src/type/gold-withdraw';

type Props = {
  filters: GoldWithdrawFilters;
  onFilters: (name: GoldWithdrawFilterKey, value: GoldWithdrawFilterValue) => void;
  dateError: boolean;
  //
  productOptions: { label: string; value: string }[];
  disabledSearch?: boolean;
  enableCreate?: boolean;
  onCreateRedeem?: VoidFunction;
};

export default function StockExportTableToolbar({
  filters,
  onFilters,
  dateError,
  productOptions,
  disabledSearch,
  enableCreate,
  onCreateRedeem,
}: Props) {
  const handleFilterName = useCallback(
    (user: UserOption | null) => {
      onFilters('name', user);
    },
    [onFilters]
  );

  const handleFilterProduct = useCallback(
    (event: SelectChangeEvent<string>) => {
      onFilters('productId', event.target.value);
    },
    [onFilters]
  );

  const handleFilterStartDate = useCallback(
    (newValue: Dayjs | null) => {
      onFilters('startDate', newValue);
    },
    [onFilters]
  );

  const handleFilterEndDate = useCallback(
    (newValue: Dayjs | null) => {
      onFilters('endDate', newValue);
    },
    [onFilters]
  );

  return (
    <Stack
      spacing={2}
      alignItems="center"
      direction={{
        xs: 'column',
        md: 'row',
      }}
      sx={{
        p: 2.5,
        width: 1,
      }}
    >
      <FilterSingleSelect
        label="ประเภทสินค้า"
        sx={{ width: { xs: 1, md: 180 } }}
        value={filters.productId}
        onChange={handleFilterProduct}
        options={productOptions}
      />

      <FilterDatePicker
        label="จากวันที่"
        value={filters.startDate}
        onChange={handleFilterStartDate}
      />
      <FilterDatePicker
        label="ถึงวันที่"
        value={filters.endDate}
        onChange={handleFilterEndDate}
        dateError={dateError}
      />

      {!disabledSearch && (
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          flexGrow={1}
          sx={{ width: { xs: 1, md: 'auto' }, minWidth: 140 }}
        >
          <UserSearchAutocomplete value={filters.name} onChange={handleFilterName} />
        </Stack>
      )}

      {enableCreate && (
        <Stack
          direction="row"
          spacing={2}
          sx={{ ml: { md: 'auto' } }}
          alignItems="center"
          width={{ xs: 1, md: 'auto' }}
        >
          <Button
            variant="contained"
            startIcon={<Iconify icon="mingcute:add-line" />}
            onClick={onCreateRedeem}
            sx={{ width: { xs: 1, md: 200 } }}
          >
            สร้างรายการถอนสินค้า
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
